export default __webpack_public_path__ + "static/media/6.638ae353.jpg";